
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CheckLatelyOrganization/CheckLatelyOrganization.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CheckLatelyOrganization.html');
        
        var script = require('./CheckLatelyOrganization.ts').default;
        module.exports = require('./CheckLatelyOrganization.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    